import { render, staticRenderFns } from "./VCheckButtonRadio.vue?vue&type=template&id=445f7310&scoped=true&"
import script from "./VCheckButtonRadio.vue?vue&type=script&lang=ts&"
export * from "./VCheckButtonRadio.vue?vue&type=script&lang=ts&"
import style0 from "./VCheckButtonRadio.vue?vue&type=style&index=0&id=445f7310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445f7310",
  null
  
)

export default component.exports